import HCLDX from "@system/config/hcldx";
import moment from "moment";
import { isNumber, isString, isArray } from "underscore";

class Helper {

  static UUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  static rangToArray(min, max) {
    let range = [];
    for (let i = min; i <= max; i++) {
      range.push(i);
    }
    return range;
  }

  static bytesToMB(bytes) {
    return bytes / (1024 ** 2);
  }

  static checkJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {
    }

    return false;
  };

  static scrollTop() {
    window.scrollTo(0, 0);
  }

  static dateFormatFromString(date, isBOM = false) {
    try {
      if (isBOM) {
        return new moment.utc(date).local().format("HH.mm, MMMM DD YYYY");
      }
      return new Date(date).toLocaleString('en-us', { year: "numeric", month: "long", day: "2-digit" })
    } catch (err) {
      return date;
    }
  }

  static convertDateFormatToMMDDYYYY(date) {
    return new moment.utc(date).local().format("MM/DD/yyyy")
  }

  static convertOrderModuleDateFormat(date) {
    return moment(date).format("MMMM DD, ") + moment(date).format("yyyy")
  }

  static checkValidURL(url) {
    let elm;
    if (url !== "") {
      if (!elm) {
        elm = document.createElement('input');
        elm.setAttribute('type', 'url');
      }
      elm.value = url;
      return elm.validity.valid;
    } else {
      return false
    }
  }

  static getSkipCount(current_page, limit) {
    let skip = limit * (current_page - 1);
    if (skip === null) {
      skip = 0;
    }
    if (!skip) {
      skip = 0;
    }
    if (skip === '') {
      skip = 0;
    }
    if (skip < 0) {
      skip = 0;
    }
    return skip;
  }

  static getDatepickerFormat() {
    return "MM/dd/yyyy"
  }


  static getHCLDXBaseUrlHost = () => {
    const _baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    if (_baseUrl) {
      const _url = new URL(_baseUrl);
      if (_url?.hostname) {
        return _url.hostname;
      }
    }
    return window.location.host;
  }



  // Create function to check value is null/empty or not
  static valueIsNotNull = (value) => {
    if (value && value.toString().trim() !== "" && !value.toString().includes("NULL"))
      return true
    else
      return false
  }

  static validateRegex = (term, expr) => {
    const re = new RegExp(expr);
    if (re.test(term)) {
      return true;
    }
    return false;
  }

  static checkObjectHaveValue = (obj) => {
    return Object.values(obj).every(value => {
      return value ? false : true
    })
  }

  static downloadFileFromRes = (data, fileName = "data") => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  static toUpperCase = (text) => {
    return text ? text.toUpperCase() : text;
  }

  static toLowerCase = (text) => {
    return text ? text.toLowerCase() : text;
  }


  static textSortingAgGrid = (valueA, valueB) => {
    const argumentA = valueA || '';
    const argumentB = valueB || '';
    return argumentA.localeCompare(argumentB);
  };
static arraySortingAgGrid = (a, b) => {
  const normalize = (val) => (Array.isArray(val) ? val.join(' ') : (val || '')).trim();

  const valA = normalize(a).toLowerCase();
  const valB = normalize(b).toLowerCase();

  // Simple alphabetical sort
  if (valA < valB) return -1;
  if (valA > valB) return 1;
  return 0;
};
  static dateSortingAgGrid = (valueA, valueB) => {
    if (!valueA || !valueB) {
      return !valueA ? -1 : 1;
    }
    return new Date(valueA) - new Date(valueB);
  }

  static calendarAgGridComparator = (valueA, valueB) => {
    if (!valueA || !valueB) {
      return !valueA ? -1 : 1;
    }
    return new Date(valueB) - new Date(valueA);
  };

  static getDatepickerFormatAdminConsole(date) {
    return moment(date).format("MMMM DD, yyyy")
  }

  static convertToYYYYMMDD = (timestamps) => {
    return timestamps.split(';').map(function (timestamp) {
      return moment(timestamp).format("yyyy-MM-DD");
    }).join(' - ');
  }

  static replaceSpecialChar = (inputStr) => {
    if (!inputStr) {
      return '';
    }

    return inputStr.replace(/\+/g, "and")
      .replace(/\&/g, "and")
      .replace(/\./g, "")
      .replace(/\//g, "-")
      .replace(/\,/g, "")
      .replace(/\s/g, "-")
      .replace(/#/g, "")
      .replace(/\---/g, "-");
  }

  static plpTabParam = "__c_HomeTabList"

  static camelToUnderscore(s) {
    return s.replace(/\.?([A-Z])/g, function (x, y) {
      return "_" + y.toLowerCase();
    }).replace(/^_/, "");
  }

  static anythingToCamel(str) {
    if (str === undefined) {
      return false;
    }
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, "");
  }

  static getTheKeyForThisAPIMaker(key) {
    let k = this.snakeToCamel(this.camelToUnderscore(key));
    k = k.replaceAll("_", "");
    k = k.toLowerCase();
    return k;
  }

  static onEnterKeyPress(e) {
    if (e.which === 13) {
      return true;
    }
  }

  static camelToDash(s) {
    return s.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? "-" : "") + match.toLowerCase());
  }

  static snakeToCamel = (str) =>
    str.toLowerCase().replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );

  static validateMinCharacter = (value) => {
    const isValid = value.length < 3 ? false : true;
    return isValid;
  }

  static roundOne = (n, q) => {
    if (n > 0)
      return Math.ceil(n / q) * q;
    else if (n < 0)
      return Math.floor(n / q) * q;
    else
      return q;
  }

  static getSystemDate() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;
    return today
  }

  static alert = (msg) => {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
      alert(msg)
    }
  }

  static getHostURL() {
    return window.location.origin;
  }

  static renderRoles(roles, roleData) {
    let renderedRoleA = '';
    if (isArray(roles) && roles?.length > 0) {
      renderedRoleA = roles.map((role) => {
        const found = roleData.find(r => role === r.roleName);
        if (!found) {
          return role;
        }
        return `${role}: ${found?.roleDescription}`
      });
      renderedRoleA = renderedRoleA.join(', ');
    }
    return renderedRoleA;
  }

  static getCreditCardDetails = (cardType) => {
    const cardDetail = {
      vi: {
        name: 'Visa',
        icon: '<i class="fa fa-cc-visa font-20 text-black"></i>',
      },
      mc: {
        name: 'MasterCard',
        icon: '<i class="fa fa-cc-mastercard font-20 text-black"></i>',
      },
      di: {
        name: 'Discover',
        icon: '<i class="fa fa-cc-discover font-20 text-black"></i>',
      },
      ae: {
        name: 'American Express',
        icon: '<i class="fa fa-cc-amex font-20 text-black"></i>',
      },
      visa: {
        name: 'Visa',
        icon: '<i class="fa fa-cc-visa font-20 text-black"></i>',
      },
      disc: {
        name: 'Discover',
        icon: '<i class="fa fa-cc-discover font-20 text-black"></i>',
      },
      amex: {
        name: 'American Express',
        icon: '<i class="fa fa-cc-amex font-20 text-black"></i>',
      },
      ax: {
        name: 'American Express',
        icon: '<i class="fa fa-cc-amex font-20 text-black"></i>',
      },
    };

    return cardDetail[cardType]
  }

  static feedBackButtonScript() {
    window.lightningjs || (function (n) {
      var e = "lightningjs";
      function t(e, t) {
        var r, i, a, o, d, c;
        return t && (t += (/\?/.test(t) ? "&" : "?") + "lv=1"), n[e] || (r = window, i = document, a = e, o = i.location.protocol, d = "load", c = 0, function () {
          n[a] = function () {
            var t = arguments, i = this, o = ++c, d = i && i != r && i.id || 0;
            function s() {
              return s.id = o, n[a].apply(s, arguments);
            }
            return (e.s = e.s || []).push([o, d, t]), s.then = function (n, t, r) {
              var i = e.fh[o] = e.fh[o] || [], a = e.eh[o] = e.eh[o] || [], d = e.ph[o] = e.ph[o] || [];
              return n && i.push(n), t && a.push(t), r && d.push(r), s;
            }, s;
          };
          var e = n[a]._ = {};
          function s() {
            e.P(d), e.w = 1, n[a]("_load");
          }
          e.fh = {}, e.eh = {}, e.ph = {}, e.l = t ? t.replace(/^\/\//, ("https:" == o ? o : "http:") + "//") : t, e.p = { 0: +new Date }, e.P = function (n) {
            e.p[n] = new Date - e.p[0];
          }, e.w && s(), r.addEventListener ? r.addEventListener(d, s, !1) : r.attachEvent("onload", s);
          var l = function () {
            function n() {
              return ["<!DOCTYPE ", o, "><", o, "><head></head><", t, "><", r, ' src="', e.l, '"></', r, "></", t, "></", o, ">"].join("");
            }
            var t = "body", r = "script", o = "html", d = i[t];
            if (!d) return setTimeout(l, 100);
            e.P(1);
            var c, s = i.createElement("div"), h = s.appendChild(i.createElement("div")), u = i.createElement("iframe");
            s.style.display = "none", d.insertBefore(s, d.firstChild).id = "lightningjs-" + a, u.frameBorder = "0", u.id = "lightningjs-frame-" + a, /MSIE[ ]+6/.test(navigator.userAgent) && (u.src = "javascript:false"), u.allowTransparency = "true", h.appendChild(u);
            try {
              u.contentWindow.document.open();
            } catch (n) {
              e.domain = i.domain, c = "javascript:var d=document.open();d.domain='" + i.domain + "';", u.src = c + "void(0);";
            }
            try {
              var p = u.contentWindow.document;
              p.write(n()), p.close();
            } catch (e) {
              u.src = c + 'd.write("' + n().replace(/"/g, String.fromCharCode(92) + '"') + '");d.close();';
            }
            e.P(2);
          };
          e.l && l();
        }()), n[e].lv = "1", n[e];
      }
      var r = window.lightningjs = t(e);
      r.require = t, r.modules = n;
    }({}));

    // Load Usabilla Live
    window.usabilla_live = window.lightningjs.require("usabilla_live", "//w.usabilla.com/5f82d58b87e9.js");

  }

  static quantitySortingAgGrid (valueA, valueB) {
    const a = parseInt(valueA?.split(',').join(''));
    const b = parseInt(valueB?.split(',').join(''));
    return a - b;
  }
  static getEmailPattern() {
  return /^[A-Za-z0-9](?:[A-Za-z0-9\-+._']*[A-Za-z0-9])?@[A-Za-z0-9]+(?:[-.][A-Za-z0-9]+)*\.[A-Za-z]{2,}$/;
}

}

export default Helper;